export default __webpack_public_path__ + "static/media/IconDesc_EncasedPlutoniumCell.64.e4c79734.png";